import type {
  IBranch,
  IDistributor,
  IPriceGroup,
  IPriceList,
  IZone,
  TCategory,
  TFamily,
} from 'core/model/interfaces/master-entities';
import type {
  IBranchDTO,
  ICategoryDTO,
  IDistributorDTO,
  IFamilyDTO,
  IPriceGroupDTO,
  IPriceListDTO,
  IZoneDTO,
} from './master-entities.dto';

export const toMasterFamilies = (data: Array<IFamilyDTO>) => {
  const response: Array<TFamily> = data.map(family => ({ label: family.name, value: family.id }));
  return response;
};

export const toMasterCategories = (data: Array<ICategoryDTO>): Array<TCategory> => {
  const response: Array<TCategory> = data.map(category => ({
    label: category.name,
    value: category.id,
    options: toMasterFamilies(category.families),
  }));
  return response;
};

export const toPriceListItem = (priceList: IPriceListDTO): IPriceList => {
  const item: IPriceList = {
    priceListId: priceList.id,
    priceListCode: priceList.externalId,
    priceListName: priceList.name,
    channelId: priceList.channelId,
  };

  return item;
};

export const toPriceList = (priceList: Array<IPriceListDTO>): Array<IPriceList> => {
  const list = priceList.map(toPriceListItem);

  return list;
};

export const toPriceGroupList = (priceGroupList: Array<IPriceGroupDTO>): Array<IPriceGroup> => {
  const list = priceGroupList.map(priceGroup => {
    const item: IPriceGroup = {
      priceGroupCode: priceGroup.externalId,
      priceGroupName: priceGroup.name,
      priceLists: priceGroup.priceLists.map(toPriceListItem),
    };

    return item;
  });

  return list;
};

export const toDistributor = (distributor: IDistributorDTO): IDistributor => {
  const item: IDistributor = {
    distributorId: distributor.id,
    distributorName: distributor.name,
  };

  return item;
};

export const toBranch = (branch: IBranchDTO): IBranch => {
  const item: IBranch = {
    branchId: branch.id,
    branchName: branch.name,
    distributor: toDistributor(branch.distributor),
  };

  return item;
};

export const toZoneList = (zoneList: Array<IZoneDTO>): Array<IZone> => {
  const list = zoneList.map(zone => {
    const item: IZone = {
      zoneId: zone.id,
      zoneName: zone.name,
      branches: zone.branches.map(toBranch),
    };

    return item;
  });

  return list;
};
